module.exports = __webpack_public_path__ + "img/shopee.d53c04c8.png";